import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arriver_news",
  "use": "icon-arriver_news-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arriver_news\"><path d=\"M601.6 857.6h-179.2c-7.68 0-15.36 7.68-12.8 15.36 7.68 40.96 51.2 74.24 102.4 74.24s92.16-30.72 102.4-74.24c0-7.68-5.12-15.36-12.8-15.36zM857.6 757.76c-2.56-2.56-69.12-33.28-71.68-133.12v-166.4c0-122.88-81.92-225.28-192-261.12 5.12-10.24 7.68-23.04 7.68-33.28C599.04 115.2 560.64 76.8 512 76.8s-87.04 38.4-87.04 87.04c0 12.8 2.56 23.04 7.68 33.28-110.08 33.28-192 138.24-192 261.12v166.4c-5.12 99.84-69.12 133.12-71.68 133.12-15.36 7.68-23.04 23.04-15.36 38.4 0 2.56 2.56 2.56 2.56 2.56s0 2.56 2.56 2.56c5.12 7.68 12.8 10.24 23.04 10.24H844.8c12.8 0 23.04-7.68 25.6-17.92 7.68-12.8 0-28.16-12.8-35.84zM532.48 186.88h-38.4c-7.68-5.12-10.24-15.36-10.24-23.04 0-15.36 12.8-30.72 30.72-30.72 15.36 0 30.72 12.8 30.72 30.72-2.56 7.68-7.68 15.36-12.8 23.04z\" p-id=\"4804\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arriver_news.svg
// module id = zs+H
// module chunks = 112